import { styled } from "@mui/material";
import { Typography } from "components";
import { success, error, warning, gray } from "configs/colors";

interface Props {
  type?: "success" | "error" | "warning" | "info";
  label: string;
}

const COLOR_MAPPING = {
  success: success[500],
  error: error[500],
  warning: warning[500],
  info: gray[500],
};

const StyledChip = styled("div")<{ dotColor: string }>(
  ({ theme, dotColor }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: "6px",
    color: theme.palette.grey[700],
    padding: "2px 6px",
    display: "flex",
    alignItems: "center",
    "&::before": {
      content: "''",
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: dotColor,
      marginRight: "4px",
    },
  })
);

const ChipStatus = (props: Props) => {
  const { type, label } = props;
  return (
    <StyledChip dotColor={COLOR_MAPPING[type || "success"]}>
      <Typography type="TextXS" color="grey.700" fontWeight="500">
        {label}
      </Typography>
    </StyledChip>
  );
};

export default ChipStatus;
